import React, { memo } from 'react';
export var DatalotPhoneIcon = /*#__PURE__*/memo(function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === void 0 ? '#003B5C' : _ref$fillColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.043 8.262l2.068-.821c.745-.247 1.572-.493 1.241-1.725L6.532.786C6.035.13 5.87-.2 4.877.13l-2.73 1.068C1.319 1.772.409 2.758.16 3.908c-1.49 6.08 7.695 20.622 13.817 22.018 1.159.247 2.483-.164 3.31-.657l2.234-1.89c.745-.739.497-1.068.083-1.807l-3.64-3.78c-.994-.82-1.573-.164-2.152.33L12.158 19.6c-3.475-2.136-6.702-7.23-7.115-11.338z",
    fill: fillColor,
    fillRule: "evenodd"
  }));
});